import React from "react";
import { Routes, Route } from "react-router-dom";
import UnSyncedCubiCasaOrders from "../components/pages/cubicasa/UnSyncedCubiCasaOrders";

const CubiCasaRoute = () => {
  return (
    <Routes>
      <Route
        path="/unsynced-cubicasa-orders"
        exact
        element={<UnSyncedCubiCasaOrders />}
      />
    </Routes>
  );
};

export default CubiCasaRoute;
